/**
 * Per-agency brand configuration — what gets stamped onto every PDF report.
 *
 * In the spike this is hard-coded ("Demo Agency"). Post-spike it's edited
 * in the dashboard and stored in IndexedDB + mirrored to Drive backup.
 */

export interface AgencyBrandConfig {
  agencyName: string;
  /** Primary brand color as hex, e.g. "#1E40AF" */
  primaryColor: string;
  /** Secondary/accent color */
  accentColor?: string;
  /** Logo as a data URL (base64). May be undefined during spike. */
  logoDataUrl?: string;
  /** Footer text, e.g. "Prepared by Lighthouse Marketing" */
  footerText?: string;
  /** Public-facing contact for the report */
  contactEmail?: string;
  contactUrl?: string;
}

export const DEFAULT_AGENCY_BRAND: AgencyBrandConfig = {
  agencyName: "Demo Agency",
  primaryColor: "#1E40AF", // Tailwind blue-700
  accentColor: "#0EA5E9", // Tailwind sky-500
  footerText: "Generated with AgencyLens",
};
